import { Tooltip, tooltipClasses } from '@mui/material';
import { styled } from '@mui/material/styles';

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#FFFFFF',
    color: '#1F2937', // Dark text
    boxShadow: '0px 2px 8px rgba(15, 23, 42, 0.1)',
    fontSize: 14,
    borderRadius: 8,
    padding: '6px 12px',
    fontWeight: 500,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#FFFFFF',
  },
}));

export default CustomTooltip;